import { render, staticRenderFns } from "./SafetyDocs.vue?vue&type=template&id=14616be2&scoped=true&"
import script from "./SafetyDocs.vue?vue&type=script&lang=js&"
export * from "./SafetyDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14616be2",
  null
  
)

export default component.exports